import React, { lazy } from 'react';
const bonuses = [{
  title: 'Full Season Weekly Planner',
  desc: '54-page visual season planner — weekly sheets to map every training session, match day and development milestone across your entire season.',
  value: '$59',
  img: 'https://cdn.magicpatterns.com/uploads/2NmA4R72692waTSbfyFcmm/B1.webp'
}, {
  title: 'Player Development Tracker',
  desc: '27-page individual player tracking system — skill milestones, progress charts and development cards for every player in your squad.',
  value: '$54',
  img: 'https://cdn.magicpatterns.com/uploads/tVAXh4uu1hf8gA2c7kLeHo/B2.webp'
}, {
  title: '50 Drill Cards — Print & Laminate',
  desc: '50 professional drill cards in a clean, printable format — take them straight to the nets.',
  value: '$64',
  img: 'https://cdn.magicpatterns.com/uploads/xcyn7R9jmYhnRw8CospYsi/b3.webp'
}, {
  title: 'Coaching Communication Pack',
  desc: '12 professional templates for parent letters, player feedback forms, season newsletters and club communication.',
  value: '$49',
  img: 'https://cdn.magicpatterns.com/uploads/5ReG3E65aQNBZ9CuXoHosP/b4.webp'
}, {
  title: 'Pre-Season Fitness Testing Pack',
  desc: '13-page complete fitness assessment system — 8 cricket-specific tests, benchmark tables by age group, individual score sheets and training prescriptions.',
  value: '$48',
  img: 'https://cdn.magicpatterns.com/uploads/n59G1yc4dvJ2mZbUkoDFzp/b5.webp'
}];
export function BonusSection() {
  return <section className="w-full bg-[#0A0A0A] py-16 px-4" data-id="element-1">
      <div className="max-w-4xl mx-auto" data-id="element-2">
        <div className="text-center mb-12" data-id="element-3">
          <h2 className="text-3xl sm:text-5xl font-black text-white mb-4 tracking-tight" data-id="element-4">
            🎁 You Also Get{' '}
            <span className="text-[#d4af37]" data-id="element-5">5 Strategic Bonuses</span>
          </h2>
          <p className="text-[#B0B0C0] text-lg font-medium mb-5" data-id="element-6">
            Included at no extra cost
          </p>
          <span className="inline-flex items-center gap-2 bg-[#16161F] border border-[#d4af37]/20 rounded-full px-5 py-2.5 text-sm sm:text-base font-bold" data-id="element-7">
            <span className="text-[#B0B0C0]" data-id="element-8">Real value:</span>
            <span className="text-[#d4af37] line-through" data-id="element-9">$274</span>
            <span className="text-[#B0B0C0]" data-id="element-10">— today included</span>
            <span className="text-[#d4af37] font-black uppercase tracking-wider" data-id="element-11">
              FREE
            </span>
          </span>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 gap-4" data-id="element-12">
          {bonuses.map((bonus, i) => <div key={i} className={`bg-[#16161F] border border-[#d4af37]/20 rounded-2xl p-6 flex flex-col ${i === 4 ? 'sm:col-span-2 sm:max-w-md sm:mx-auto w-full' : ''}`} data-id="element-13">
              <div className="relative mb-5 rounded-xl overflow-hidden bg-[#0A0A0A]" data-id="element-14">
                <img src={bonus.img} alt={bonus.title} loading="lazy" className="w-full h-52 object-cover" width={1024} height={1024} data-id="element-15" />
              </div>
              <div className="flex items-center justify-between mb-4" data-id="element-16">
                <span className="text-[#d4af37] font-black text-sm tracking-wider uppercase" data-id="element-17">
                  Bonus 0{i + 1}
                </span>
                <span className="inline-flex items-center gap-1.5 bg-[#d4af37]/10 text-[10px] font-black px-2.5 py-1 rounded-full uppercase tracking-wider" data-id="element-18">
                  <span className="text-[#B0B0C0] line-through" data-id="element-19">
                    {bonus.value}
                  </span>
                  <span className="text-[#d4af37]" data-id="element-20">FREE</span>
                </span>
              </div>
              <h4 className="text-white font-bold text-lg mb-2 leading-tight" data-id="element-21">
                {bonus.title}
              </h4>
              <p className="text-[#B0B0C0] text-sm font-medium leading-relaxed" data-id="element-22">
                {bonus.desc}
              </p>
            </div>)}
        </div>
      </div>
    </section>;
}